module.exports = __webpack_public_path__ + "fonts/HelveticaNeue.aa01b0b6.woff2";